import Banner from 'components/Banner';
import CareerForm from 'components/FormSection/Forms/CareerForm';
import GradientText from 'components/GradientText';
import JobCards from 'components/JobCards';
import MarqueeGallery from 'components/MarqueeGallery';
import MissionAndValuesSection from 'components/MissionAndValuesSection';
import { careerData } from 'components/MissionAndValuesSection/mockData';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCareer } from 'store/getCareerSlice';

const Career = () => {
    const dispatch = useDispatch();
    const {
        fs_title,
        about_tag,
        fs_title_background,
        about_title,
        about_description,
        open_jobs_tag,
        open_jobs_title,
        git_tag,
        git_title,
        git_text,
        team_gallery,
        team_title,
        vacancies,
    } = useSelector(state => state?.career?.data?.data) || {};

    useEffect(() => {
        dispatch(fetchCareer());
    }, []);

    return (
        <>
            <Banner image={fs_title_background} buttonText="View open jobs">
                <GradientText size="middle" textColor="white">
                    {/* We’re always looking people <br />
                    <em>to help us become better</em> */}
                    <span dangerouslySetInnerHTML={{ __html: fs_title }} />
                </GradientText>
            </Banner>

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>{about_tag}</LabelButton>
                        <GradientText>
                            {/* Unifer as a medium-sized international
                            <img src={image} alt="decor" />
                            company offers <em>great opportunities for career growth</em> */}
                            <span dangerouslySetInnerHTML={{ __html: about_title }} />
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                {/* We are not saying that we are unique, but believe us, companies like ours are not that
                                common. */}
                                {about_description}
                            </GradientText>
                        </div>
                    </div>
                </div>
            </section>

            {/* TODO: wait updates admin panel */}
            <MissionAndValuesSection data={careerData} />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>{open_jobs_tag}</LabelButton>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="middle">
                                <span dangerouslySetInnerHTML={{ __html: open_jobs_title }} />
                                {/* Join our team and be part of the future of <em>agricultural success</em> */}
                            </GradientText>
                        </div>
                    </div>
                    <JobCards data={vacancies} />
                </div>
            </section>

            <MarqueeGallery images={team_gallery} title={team_title} />

            <section className="container">
                <div className="inner-container type-3">
                    <div className="main-text-container">
                        <LabelButton>{git_tag}</LabelButton>
                        <GradientText size="middle">
                            {/* If you would like to learn more about <em>career opportunities at our company,</em> please
                            contact us! */}
                            <span dangerouslySetInnerHTML={{ __html: git_title }} />
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                {/* Even if you haven't found your dream job on this page, we may still be able to offer you
                                an internship with us. */}
                                <span dangerouslySetInnerHTML={{ __html: git_text }} />
                            </GradientText>
                        </div>
                    </div>
                </div>
            </section>

            <CareerForm />
        </>
    );
};

export default Career;
